import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Container,
  LoadingBounce,
  Panel,
} from '@michelin/acid-components';
import { ChangeLogEntities } from 'Types';
import useCommercialLocation from 'hooks/useCommercialLocation';
import useCustomer from 'hooks/useCustomer';
import { PlainMessage } from 'components/PlainMessage';
import useUtils from 'hooks/useUtils';
import { useCommercialNetworkServices } from 'hooks/useCommercialServices';
import { TABBED_CONTENT_HEIGHT } from 'Utils';
import LastModified from 'components/ChangeLog/LastModified';
import { useCommercialOverrides } from 'hooks/useCommercialOverrides';
import { PageTitle } from 'Utils/CanvasPageTitle';
import CommercialNetworksPanel from './CommercialNetworksPanel';

interface Props {
  action: 'edit' | 'view' | 'add',
}

export function CommercialNetworks(props: Props) {
  const { t } = useTranslation();
  const { stNumber } = useParams<{ stNumber: string }>();
  const commercialQuery = useCommercialLocation(stNumber);
  const customerQuery = useCustomer(stNumber);
  const commercialNetworks = useCommercialNetworkServices(stNumber);
  const commercialOverrides = useCommercialOverrides(stNumber);
  const { subTitle } = useUtils();

  if (commercialQuery.isLoading || customerQuery.isLoading || commercialNetworks.isLoading) return <LoadingBounce style={{ height: '70vh' }} />;
  if (!commercialNetworks.data) return <PlainMessage title={t('Error loading commercial services')} messages={t('Please try again later')} />;

  if (commercialOverrides.isLoading || commercialOverrides.isLoading || commercialOverrides.isLoading) return <LoadingBounce style={{ height: '70vh' }} />;
  if (!commercialOverrides.data) return <PlainMessage title={t('Error loading commercial services')} messages={t('Please try again later')} />;

  return (
    <>
      <PageTitle
        title={t('Commercial Networks')}
        subtitle={subTitle}
        rightItems={(<LastModified entity={ChangeLogEntities.services} />)}
      />
      <Container>
        <Panel style={{ minHeight: TABBED_CONTENT_HEIGHT }}>
          <CommercialNetworksPanel
            networks={commercialNetworks.data}
            action={props.action}
            commercialOverrides={commercialOverrides.data}
          />
        </Panel>
      </Container>

    </>
  );
}

